import { createAction, props } from '@ngrx/store';
import { BackupCode } from '@app/auth/models';
import { ActionTypes } from '@app/auth/routes/login/state/login.actions';

export const recoveryVerifyCode = createAction(ActionTypes.VERIFY_2FA_VIA_RECOVERY_CODE, props<BackupCode>());
